import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../AuthContext.jsx'
import { getPrice } from '../api.js'
import { trackEvent } from '../analytics.js'

export default function Success() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { refreshUser } = useAuth()
  const [redirecting, setRedirecting] = useState(false)
  const priceDataRef = useRef(null)

  useEffect(() => {
    getPrice().then(r => { priceDataRef.current = r.data }).catch(() => {})
  }, [])

  useEffect(() => {
    const timer = setTimeout(async () => {
      setRedirecting(true)
      trackEvent('purchase', {
        currency: priceDataRef.current?.currency ?? 'USD',
        user_segment: 'subscribed',
      })
      await refreshUser()
      navigate('/chat', { replace: true })
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate, refreshUser])

  return (
    <div className="result-page">
      <div className="check-icon">✓</div>
      <div className="result-title">{t('checkout.activated')}</div>
      <div className="result-sub">
        {redirecting ? t('checkout.taking') : t('checkout.redirecting')}
      </div>
    </div>
  )
}
